import { focusRing } from '@ths/ui';

import THSFooterLogo from '../assets/ths-footer-logo.svg';
import { useAppSelector } from '../store/store';
import { useContactEmail } from '../utilities/useContactEmail';

const navigation = {
  services: [
    {
      name: 'Base Camps & Life Support Services',
      href: 'https://www.teamhousing.com/base-camps-life-support-services',
    },
    {
      name: 'Group Hotel Lodging',
      href: 'https://www.teamhousing.com/group-hotel-lodging',
    },
    {
      name: 'Furnished Apartments & Homes',
      href: 'https://www.teamhousing.com/furnished-apartments-homes',
    },
    {
      name: 'Workforce Housing',
      href: 'https://www.teamhousing.com/workforce-housing',
    },
    {
      name: 'Emergency & Disaster Response',
      href: 'https://www.teamhousing.com/emergency-disaster-response',
    },
  ],
  company: [
    {
      name: 'About Us',
      href: 'https://www.teamhousing.com/about-us',
    },
    {
      name: 'Careers',
      href: 'https://www.teamhousing.com/careers/',
    },
    {
      name: 'THS In Action',
      href: 'https://www.teamhousing.com/ths-in-action',
    },

    {
      name: 'NAICS & PSC Codes',
      href: 'https://www.teamhousing.com/naics-psc-codes',
    },
  ],
};

export default function Footer() {
  const { contactEmail } = useContactEmail();
  const savedCardsEnabled = useAppSelector(
    (state) => state.enums.featureFlags?.flags.hotelSavedCards === true,
  );

  return (
    <div className="flex flex-col">
      <footer className="bg-darkBlue" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-20">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-8">
              <img className="h-14" src={THSFooterLogo} alt="Company name" />
              <p className="text-base leading-6 text-gray-300">
                Our mission is to provide superior temporary lodging services to
                organizations with traveling professionals across the United
                States and internationally. We utilize superior systems to
                provide impeccable service to every client. We recognize our
                team, our supplier partners, and our clients as valuable parts
                of the extraordinary housing experience for guests and clients.
              </p>
            </div>
            <div className="mt-16 grid grid-cols-3 gap-8 xl:col-span-2 xl:mt-0">
              <div className="md:col-span-2 md:grid md:gap-8 lg:grid-cols-2">
                <div>
                  <h3 className="text-base font-semibold leading-6 text-white xl:text-right">
                    Our Solutions
                  </h3>
                  <ul className="mt-6 space-y-4">
                    {navigation.services.map((item) => (
                      <li key={item.name} className="xl:text-right">
                        <a
                          href={item.href}
                          className="text-sm leading-6 text-gray-300 hover:text-white"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-10 md:mt-0">
                  <h3 className="text-base font-semibold leading-6 text-white xl:text-right">
                    Company
                  </h3>
                  <ul className="mt-6 space-y-4">
                    {navigation.company.map((item) => (
                      <li key={item.name} className="xl:text-right">
                        <a
                          href={item.href}
                          className="text-sm leading-6 text-gray-300 hover:text-white"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="mt-10 md:mt-0 xl:text-right">
                <h3 className="text-base font-semibold leading-6 text-white">
                  Contact Us
                </h3>
                <ul className="mt-6 space-y-4">
                  <li className="text-sm leading-6 text-gray-300 hover:text-white">
                    707 Landa, Suite A<br />
                    New Braunfels, TX 78310
                  </li>
                  <li>
                    <a
                      href={`mailto:${contactEmail}`}
                      className="text-sm font-semibold leading-6 text-gray-300 hover:text-white"
                    >
                      {contactEmail}
                    </a>
                  </li>
                  <li>
                    <a
                      href="tel:8306098855"
                      className="text-sm leading-6 text-gray-300 hover:text-white"
                    >
                      830.609.8855
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
            {savedCardsEnabled && (
              <a
                href="/terms"
                className={`text-body text-on-accent underline ${focusRing}`}
              >
                Terms of service
              </a>
            )}
            <p className="text-xs leading-5 text-gray-400">
              Copyright © {new Date().getFullYear()} Team Housing Solutions,
              All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
